import { authRoles } from '@/core/constants'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, BUSINESS } = authRoles

const Promotions = () =>
  import(/* webpackChunkName: "promotions-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/promotions',
    name: 'promotions',
    component: Promotions,
    meta: {
      title: 'Promociones',
      auth: {
        roles: [ADMIN, BUSINESS], // Roles permitidos
        redirect: '/auth/login', // Redirección si no está autenticado
        forbiddenRedirect: '/403', // Redirección si no tiene los roles necesarios
      },
    },
  },
]
